// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.internwidgets-inline-1 {
  margin-bottom: 20px;
}

.internwidgets-inline-2 {
  text-align: right;
}

.internwidgets-inline-3 {
  cursor: pointer;
}

.internwidgets-inline-4 {
  margin-top: 16px;
  border-top: 1px solid #f1f5f9;
  padding-top: 16px;
}

.internwidgets-inline-5 {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-muted);
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.internwidgets-dyn-1 {
  width: var(--internwidgets-1-width);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Intern/InternWidgets.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":[".internwidgets-inline-1 {\n  margin-bottom: 20px;\n}\n\n.internwidgets-inline-2 {\n  text-align: right;\n}\n\n.internwidgets-inline-3 {\n  cursor: pointer;\n}\n\n.internwidgets-inline-4 {\n  margin-top: 16px;\n  border-top: 1px solid #f1f5f9;\n  padding-top: 16px;\n}\n\n.internwidgets-inline-5 {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-muted);\n  margin-bottom: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.internwidgets-dyn-1 {\n  width: var(--internwidgets-1-width);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
